import { createLoadDocumentsMethod } from './load-documents';
import { createLoadCategoriesMethod } from './load-categories';
import { createSortDocumentsMethod } from './sort-documents';
import { createFilterMethods } from './filter-methods';
import { createFilterDocumentsMethod } from './filter-documents';

/**
 * Belge yükleme metodlarını oluşturur
 *
 * @param {Object} state - Uygulama state
 * @param {Object} services - Servisler
 * @returns {Object} Belge yükleme metodları
 */
export const createDocumentLoadMethods = (state, services) => {
  // Filtreleme yapmak için gerekli olan alt metodlar
  const filterMethods = createFilterMethods();
  
  // Sıralama metodu
  const sortDocuments = createSortDocumentsMethod(state);
  
  // Filtreleme metodu (sıralama metodunu kullanır)
  const filterDocuments = createFilterDocumentsMethod(state, filterMethods, sortDocuments);
  
  // Belge yükleme metodu (filtreleme metodunu kullanır)
  const loadDocuments = createLoadDocumentsMethod(state, services, filterDocuments);
  
  // Kategori yükleme metodu
  const loadCategories = createLoadCategoriesMethod(state, services);

  /**
   * Belgeleri yenile
   */
  const refreshDocuments = () => {
    return loadDocuments();
  };

  /**
   * Sayfalamayı sıfırla
   */
  const resetPagination = () => {
    state.pagination.currentPage = 1;
  };

  // Public API
  return {
    loadDocuments,
    loadCategories,
    refreshDocuments,
    filterDocuments,
    resetPagination,
  };
};